export const CompanyStatus = {
  queued: {
    Color: "#6ec6ff",
    Text: "Queued",
    Description: "Company is currently queued on the connector for syncing.",
  },
  Syncing: {
    Color: "#6184D8",
    Text: "Syncing",
    Description: "Company is currently syncing on the connector.",
  },
  STATE_SYNCING: {
    Color: "#6184D8",
    Text: "Syncing",
    Description: "Company is currently syncing on the connector.",
  },
  Done: {
    Color: "#54c6b8",
    Text: "Done",
    Description: "Company has finished syncing successfully",
  },
  Idle: {
    Color: "#13CE66",
    Text: "Online",
    Description: "Company is waiting for the next sync.",
  },
  Failed: {
    Color: "#FF4949",
    Text: "Failed",
    Description:
      "Company failed to sync. This should only be of concern if it happens repeatedly.",
  },

  Shutdown: {
    Color: "#FF4949",
    Text: "Shutdown",
    Description: "Connector is shut down",
  },

  "Shutting-Down": {
    Color: "#FF4949",
    Text: "Shutting-down",
    Description: "Connector is shutting down",
  },

  Offline: {
    Color: "#29262B",
    Text: "Offline",
    Description: "Connector is offline.",
  },
  Uninstalled: {
    Color: "Red",
    Text: "Uninstalled",
    Description: "Connector is uninstalled.",
  },
};

export type CompanyStatusType = keyof typeof CompanyStatus;

export function GetCompanyStatus(key: CompanyStatusType | "STATE_IDLE") {
  if (key === "STATE_IDLE") {
    return CompanyStatus.Idle;
  }

  const found = CompanyStatus[key];

  if (!found) {
    return {
      Color: "#54c6b8",
      Text: "-",
      Description: "",
    };
  }

  return found;
}
